export function isPreAuthNonOnboardingHeader(isAuthed: boolean): boolean {
    let _isPreAuthNonOnboardingHeader = false;

    if (isAuthed) {
        _isPreAuthNonOnboardingHeader = false;
    } else if (
        window.location.pathname.includes("login") ||
        window.location.pathname.includes("forgot-password") ||
        window.location.pathname.includes("reset-password") ||
        window.location.pathname.includes("providers") ||
        window.location.pathname.includes("verify-onboarding") ||
        window.location.pathname.includes("sign-up")
    ) {
        _isPreAuthNonOnboardingHeader = true;
    }

    return _isPreAuthNonOnboardingHeader;
}

export function isOnboardingHeader(): boolean {
    let _isOnboardingHeader = false;

    if (
        window.location.pathname.includes("/therapy/initquestions") ||
        window.location.pathname.includes("/therapy/opt-out")
    ) {
        _isOnboardingHeader = true;
    }

    return _isOnboardingHeader;
}
